

module.exports = __webpack_require__.stylable.create(
    "Grid2482521589",
    {"classes":{"root":"Grid2482521589__root","item":"Grid2482521589__item","listWrapper":"Grid2482521589__listWrapper"},"vars":{},"stVars":{"DefaultDividerColor":"color-5","MainDividerColor":"--overridable","dividerColor":"\"color(fallback(--overridable, opacity(color(color-5), 0.2)))\""},"keyframes":{}},
    "",
    1,
    "Grid2482521589",
    null
);
